import { render } from "./ChatWithTss.vue?vue&type=template&id=58393be7&scoped=true"
import script from "./ChatWithTss.vue?vue&type=script&lang=js"
export * from "./ChatWithTss.vue?vue&type=script&lang=js"

import "./ChatWithTss.vue?vue&type=style&index=0&id=58393be7&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58393be7"]])

export default __exports__